import { useEffect } from 'react';

export const usePageTitle = (title: string) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = `${title} - OS Workflow`;
    
    // Reset title on unmount
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};

export default usePageTitle;